var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEngagement4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 24,
    viewBox: "0 0 419 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 418.75,
    y: 12.75,
    width: 418.5,
    height: 0.500018,
    transform: "rotate(180 418.75 12.75)",
    stroke: "#E6E0FF",
    strokeWidth: 0.500018
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    fill: "#714EF5",
    fillOpacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 12.5,
    r: 4.5,
    fill: "#714EF5",
    fillOpacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 12.5,
    r: 4.5,
    fill: "#714EF5",
    fillOpacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 12,
    r: 12,
    fill: "#714EF5",
    fillOpacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 13,
    r: 6,
    fill: "#714EF5",
    fillOpacity: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 12,
    r: 6,
    fill: "#79F5BA",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagement4);
export default __webpack_public_path__ + "static/media/engagement-4.c7a26633a666f002c1a7b493a7ee03af.svg";
export { ForwardRef as ReactComponent };